import { useEffect } from "react";
import { setSidebarExpanded } from "@/modules/app/appSlice";
import { useAppDispatch } from "@/modules/app/useAppContext";
import { SMALL_SCREEN_BREAKPOINT } from "@/helpers/constants";

const SidebarResizeListener = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    let isSmallScreenOnMount = window.innerWidth < SMALL_SCREEN_BREAKPOINT;
    dispatch(setSidebarExpanded(!isSmallScreenOnMount));

    const handleResize = () => {
      const currentIsSmallScreen = window.innerWidth < SMALL_SCREEN_BREAKPOINT;
      if (currentIsSmallScreen !== isSmallScreenOnMount) {
        isSmallScreenOnMount = currentIsSmallScreen;
        dispatch(setSidebarExpanded(!isSmallScreenOnMount));
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch]);

  return <></>;
};

export default SidebarResizeListener;
